<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <form nz-form [formGroup]="validateForm">
      <nz-card>
        <span class="Risklabel">{{ "InvoiceInfo" | translate }}</span>
        <div class="action-bar">
          <div class="action-bar__left">
            <button nz-button nzType="primary" class="default-button" (click)="addRow()"><span nz-icon nzType="plus" nzTheme="outline"></span>{{'Add'|translate}}</button>
            <button nz-button nzType="primary" class="default-button" (click)="exportTableToExecl()"><span nz-icon nzType="download" nzTheme="outline"></span>{{'DownloadExcel'|translate}}</button>
            <nz-upload [nzFileList]="fileList" [nzBeforeUpload]="beforeUpload">
              <button nz-button class="upload-button default-button">
                <span nz-icon nzType="upload" nzTheme="outline"></span>{{'UploadExcel'|translate}}
              </button>
            </nz-upload>
            <button class="default-button" nz-button (click)="WHQSubmitList()" nzType="primary" [disabled]="FirstsetOfCheckedId.size === 0"><span nz-icon nzType="send" nzTheme="outline"></span>{{'Submit'|translate}}</button>
            <ng-container *ngIf="showSaveBtn">
              <button class="default-button" nz-button (click)="SavegetmaintainData()" nzType="primary"><span nz-icon nzType="save" nzTheme="outline"></span>{{'Save'|translate}}</button>
            </ng-container>
            <button class="default-button" nz-button (click)="Revocation()" nzType="primary"><span nz-icon nzType="undo" nzTheme="outline"></span>{{'revocation'|translate}}</button>
            <ng-container *ngIf="showDeptBtn">
              <button nz-button class="default-button" nz-tooltip nzTooltipTitle="{{'更改挂賬部門代碼' | translate}}" (click)="DeptSearch()" nzType="primary"><span nz-icon nzType="contacts" nzTheme="outline"></span>{{'dept'|translate}}</button>
            </ng-container>
            <button nz-button nzType="primary" class="default-button" (click)="Retrun()"><span nz-icon nzType="arrow-left" nzTheme="outline"></span>{{'Return'|translate}}</button>
          </div>
          <div class="action-bar__right">
            <ng-container *ngIf="showRejectBtn">
              <button class="btn-reject" nz-button (click)="Reject()"><span nz-icon nzType="close" nzTheme="outline"></span>{{'Rejected'|translate}}</button>
            </ng-container>
            <ng-container *ngIf="showApproveBtn">
              <button class="btn-approve" nz-button (click)="GetPaymentModel()"><span nz-icon nzType="check" nzTheme="outline"></span>{{'Approved'|translate}}</button>
            </ng-container>
          </div>
          <!-- <div nz-col *ngIf="showSaveBtn">
            <button class="default-button" nz-button (click)="SavegetmaintainData()" nzType="primary"><span nz-icon
                nzType="save" nzTheme="outline"></span>
              {{'Save'|translate}}</button>
          </div>
          <div nz-col *ngIf="showApproveBtn">
            <button class="default-button" nz-button (click)="GetPaymentModel()" nzType="primary"><span nz-icon
                nzType="check" nzTheme="outline"></span>
              {{'Approved'|translate}}</button>
          </div>
          <div nz-col *ngIf="showRejectBtn">
            <button class="default-button" nz-button (click)="Reject()" nzType="primary"><span nz-icon nzType="close"
                nzTheme="outline"></span>
              {{'Rejected'|translate}}</button>
          </div>
          <div nz-col>
            <button class="default-button" nz-button (click)="Revocation()" nzType="primary"><span nz-icon nzType="undo"
                nzTheme="outline"></span>
              {{'revocation'|translate}}</button>
          </div>
          <div nz-col nz-button *ngIf="showDeptBtn">
            <button class="default-button" nz-tooltip nzTooltipTitle="{{'更改挂賬部門代碼' | translate}}" (click)="DeptSearch()"
              nzType="primary"><span nz-icon nzType="contacts" nzTheme="outline"></span>
              {{'dept'|translate}}</button>
          </div>
          <div nz-col>
            <button nz-button nzType="primary" class="default-button" (click)="Retrun()"><span nz-icon
                nzType="arrow-left" nzTheme="outline"></span>
              {{'Return'|translate}}</button>
          </div> -->
        </div>

        <div class="表格" style="margin-top: 15px;">

          <nz-table [nzShowPagination]="false" #editRowTable nzBordered nzShowSizeChanger [nzFrontPagination]="false"
            [nzPageSize]='pageSize' [nzPageIndex]='pageIndex' (nzCurrentPageDataChange)="FirstPageDataChange($event)"
            [nzScroll]="{ y: '600px',x:'1500px' }">
            <thead>
              <tr>
                <th scope="col" nzWidth="40px" style="text-align: center;" [(nzChecked)]="Firstchecked"
                  [nzIndeterminate]="Firstindeterminate" (nzCheckedChange)="FirstonAllChecked($event)"></th>
                <th scope="col" nzWidth="70px">{{"InvoiceStatus" | translate}}</th>
                <th scope="col" nzWidth="120px" style="text-align: center;">{{ "PoNo" | translate}}</th>

                <th scope="col" nzWidth="120px" style="text-align: center;">{{ "InvoiceNo" | translate}}

                </th>
                <th scope="col" nzWidth="130px" style="text-align: center;">{{ "InvoiceDate" | translate}}
                  <div style="margin-top: 5px;">
                    <span (click)="AsFirst('InvoiceDate')" nz-icon nzType="vertical-align-bottom" nzTheme="outline"
                      style="font-size: 20px;cursor: pointer;"></span>
                  </div>
                </th>

                <th scope="col" nzWidth="100px" style="text-align: center;">{{ "UseElectronicInvoice" | translate}}</th>
                <th scope="col" nzWidth="60px" style="text-align: center;">{{ "Verify" | translate}}</th>
                <th scope="col" nzWidth="70px" style="text-align: center;">{{ "table.WHQCurrency" | translate}}</th>
                <th scope="col" nzWidth="100px" style="text-align: center;">{{ "InvoiceAmountBeforeTax" | translate}}
                </th>
                <th scope="col" nzWidth="100px" style="text-align: center;">{{ "Taxes" | translate}}</th>
                <th scope="col" nzWidth="200px" style="text-align: center;">{{ "Remark" | translate}}</th>
                <th scope="col" nzWidth="150px" style="text-align: center;">{{ "ElectronicFileInvoice" | translate}}
                </th>
                <th scope="col" nzWidth="150px" style="text-align: center;">{{ "OtherFiles" | translate}}</th>
                <th scope="col" nzWidth="150px" style="text-align: center;">{{ "BuyerOtherFiles" | translate}}</th>
                <th scope="col" nzWidth="70px" style="text-align: center;" class="fixed-column">{{ "act" | translate}}
                </th>
              </tr>
            </thead>

            <ng-container formArrayName="aliases">

              <tr [formGroupName]="i" *ngFor="let data of aliases.controls;let i=index">
                <ng-container>
                  <td nzHigh="30px" [nzChecked]="FirstsetOfCheckedId.has(data.value.bind_id)"
                    (nzCheckedChange)="FirstonItemChecked(data.value.bind_id, $event,i)"></td>
                  <td>{{data.value.Invoicestatus}}</td>
                  <td nzHigh="100px">
                    {{data.value.Pono}}
                  </td>

                  <td>

                    <nz-input-group nzSearch>
                      <input type="text" nz-input (mouseenter)="InvoiceNoMsgShow('InvoiceNo')"
                        oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')" formControlName="InvoiceNo"
                        text-transform:uppercase (ngModelChange)="ngModelChange(data.value)" />
                    </nz-input-group>
                    <ng-template #suffixIconButton>


                    </ng-template>

                    <!-- <input type="text" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'').toUpperCase()" nz-input (mouseenter)="InvoiceNoMsgShow('InvoiceNo')" (mouseleave)="CloseInput('qqqq')"
                     formControlName="InvoiceNo" text-transform:uppercase (ngModelChange)="InvoiceNoChange(data.value)"
                    placeholder="{{'InvoiceCodeInvoiceNoRequired'|translate}}" /> -->
                  </td>
                  <!-- <td >
                    <nz-select  formControlName="InvoiceNo"  (nzOnSearch)="userSearch($event)" style="width: 150px;"
                    (ngModelChange)="InvoiceNoChange(data.value)"
                    (mouseenter)="InvoiceNoMsgShow('InvoiceNo')" (mouseleave)="CloseInput('qqqq')"
                     [nzAllowClear]="true" [nzShowSearch]="true">
                     <nz-option  *ngFor="let o of OptionList" [nzValue]="o.invoiceNo" [nzLabel]="o.invoiceNo" nzCustomContent>
                      <span>{{o.invoiceNo}}</span>
                     </nz-option>
                     </nz-select>
                </td> -->
                  <td>
                    <nz-date-picker formControlName="InvoiceDate" [nzFormat]="dateFormat" style="width:100%;"
                      [nzDisabledDate]="disabledDate" nzPlaceHolder="{{'selectMonth'|translate}}">
                    </nz-date-picker>
                  </td>

                  <td style="text-align:center;">
                    <nz-switch formControlName="InvoiceSwitch" nzUnCheckedChildren="{{'manual' |translate }}"
                      nzCheckedChildren="{{'twEinv' |translate }}" (click)="InvoiceNoChange(data.value,i)"></nz-switch>
                  </td>
                  <td style="text-align:center;" *ngIf="!data.value.InvoiceSwitch">
                    <!-- <span nz-icon nzType="question-circle" nzTheme="twotone" style="font-size: 20px;"></span> -->
                    <!-- <button nz-button nzType="primary" nzSearch >
                  <span nz-icon nzType="search" (click)="InvoiceNoChange(data.value,i)"  ></span></button> -->
                  </td>

                  <td style="text-align:center;" *ngIf="data.value.InvoiceSwitch">
                    <span nz-icon nzType="check-circle" nzTheme="twotone" style="font-size: 20px;"></span>
                    <!-- <button nz-button nzType="primary" nzSearch >
                  <span nz-icon nzType="search" (click)="InvoiceNoChange(data.value,i)"  ></span></button> -->
                  </td>

                  <td style="text-align:center;">
                    {{data.value.Currency}}
                  </td>
                  <td style="text-align: right; word-break:break-all;" *ngIf="data.value.Currency!='NTD'">
                    <input type="text" oninput="value" nz-input style="text-align: right; word-break: break-all;"
                      formControlName="NontaxInvoiceAmount" />
                  </td>
                  <td style="text-align: right; word-break:break-all;" *ngIf="data.value.Currency=='NTD'">
                    <input type="text" oninput="value" nz-input style="text-align: right; word-break:break-all;"
                      formControlName="NontaxInvoiceAmount" />
                  </td>

                  <td style="text-align: right; word-break:break-all;" *ngIf="data.value.Currency!='NTD'">
                    <input type="text" oninput="value" nz-input style="text-align: right; word-break:break-all;"
                      formControlName="Taxes" />
                  </td>
                  <td style="text-align: right; word-break:break-all;" *ngIf="data.value.Currency=='NTD'">
                    <input type="text" oninput="value" nz-input style="text-align: right; word-break:break-all;"
                      formControlName="Taxes" />
                  </td>

                  <td>
                    <textarea nz-input nzAutosize formControlName="Remark"></textarea>
                  </td>

                  <!-- 发票文件 -->
                  <td *ngIf="data.value.invoicefilePath!='' && data.value.invoicefilePath!=null"
                    style="text-align:center;">
                    <div>
                      <!-- <span class="linkLabel" style="text-decoration:underline;color:blue"> -->
                      <span nz-icon nzType="file" nzTheme="twotone"
                        style="font-size: 20px;margin-right: 5px;cursor: pointer;" nz-tooltip
                        nzTooltipTitle="{{data.value.invoicefileName}}" (click)="GetFileTokenOnClick(data)"></span>
                      <button nz-icon nzType="delete" nzTheme="outline" (click)="DeleteUploadFile(data)"></button>
                    </div>
                  </td>
                  <td *ngIf="data.value.invoicefilePath=='' || data.value.invoicefilePath==null ">
                    <nz-upload [nzBeforeUpload]="beforeUploadFile">
                      <button nz-button class="upload-button default-button"
                        [disabled]="data.value.NontaxInvoiceAmount==0" (click)="GetRowInfo(data.value,i)">
                        <em nz-icon nzType="upload"></em>{{'SelectFile'|translate}}
                      </button>
                    </nz-upload>
                  </td>

                  <!-- 发票附档 -->
                  <td *ngIf="data.value.otherfilePath!='' && data.value.otherfilePath!=null" style="text-align:center;">
                    <div>
                      <span nz-icon nzType="file" nzTheme="twotone"
                        style="font-size: 20px;margin-right: 5px;cursor: pointer;" nz-tooltip
                        nzTooltipTitle="{{data.value.otherInvoicefileName}}"
                        (click)="GetOtherFileTokenOnClick(data)"></span>
                      <button nz-icon nzType="delete" nzTheme="outline" (click)="DeleteUploadOtherFile(data)"></button>
                    </div>
                  </td>
                  <td *ngIf="data.value.otherfilePath=='' || data.value.otherfilePath==null ">
                    <nz-upload [nzFileList]="fileList" [nzBeforeUpload]="beforeUploadOtherFile">
                      <button nz-button class="upload-button default-button" (click)="GetRowInfo(data.value,i)"
                        [disabled]="data.value.NontaxInvoiceAmount==0">
                        <em nz-icon nzType="upload"></em>{{'SelectFile'|translate}}
                      </button>
                    </nz-upload>
                  </td>

                  <!-- 发票采购附档 -->
                  <td *ngIf="data.value.buyerOtherFiles!='' && data.value.buyerOtherFiles!=null"
                    style="text-align:center;">
                    <div>
                      <span nz-icon nzType="file" nzTheme="twotone"
                        style="font-size: 20px;margin-right: 5px;cursor: pointer;" nz-tooltip
                        nzTooltipTitle="{{data.value.buyerOtherFilesfileName}}"
                        (click)="GetBuyerOtherFile(data)"></span>
                      <button nz-icon nzType="delete" nzTheme="outline" (click)="DeleteBuyerOtherFiles(data)"></button>
                    </div>
                  </td>
                  <td *ngIf="data.value.buyerOtherFiles=='' || data.value.buyerOtherFiles==null ">
                    <nz-upload [nzFileList]="fileList" [nzBeforeUpload]="beforeBuyerOtherFiles">
                      <button nz-button class="upload-button default-button" (click)="GetRowInfo(data.value,i)"
                        [disabled]="data.value.NontaxInvoiceAmount==0">
                        <em nz-icon nzType="upload"></em>{{'SelectFile'|translate}}
                      </button>
                    </nz-upload>
                  </td>
                  <td style="text-align:center ;background-color: #fff;" class="fixed-column">
                    <span nz-icon nzType="delete" nzTheme="twotone" (click)="deleteRow(i,data.value)"
                      style="font-size: 20px; cursor: pointer;" nz-tooltip
                      nzTooltipTitle="{{'Delete' | translate}}"></span>
                  </td>
                </ng-container>
              </tr>

            </ng-container>

          </nz-table>

        </div>
      </nz-card>
    </form>
    <form nz-form [formGroup]="RTDetailForm">
      <nz-card style="margin-top: 10px;">
        <span class="Risklabel">{{ "PADetail" | translate }}</span>
        <div nz-row nzGutter="64">
          <div nz-col>
            <button nz-button nzType="primary" class="default-button" (click)="addDetail()"><span nz-icon nzType="plus"
                nzTheme="outline"></span>
              {{'Add'|translate}}</button>
          </div>
        </div>
        <nz-table [nzShowPagination]="false" nzSize="middle" #editRowTable nzSize="middle" nzBordered
          style="width: 100%;margin-top: 10px;" [nzScroll]="{ y: '600px',x:'1000px' }">
          <thead>
            <tr>
              <th scope="col" nzWidth="150px" style="text-align: center;">{{ "InvoiceNo" | translate}}
                <div style="margin-top: 5px;">
                  <span (click)="AsFirst('InvoiceNo')" nz-icon nzType="vertical-align-bottom" nzTheme="outline"
                    style="font-size: 20px;cursor: pointer;"></span>
                </div>
              </th>
              <th scope="col" nzWidth="150px" style="text-align: center;">{{ "PoNo" | translate}}</th>
              <th scope="col" nzWidth="150px" style="text-align: center;">{{ "table.POLN" | translate}}

              </th>
              <th scope="col" nzWidth="100px" style="text-align: center;">{{ "POAmount" | translate}}</th>
              <th scope="col" nzWidth="100px" style="text-align: center;">{{ "table.Price" | translate}}</th>
              <th scope="col" nzWidth="100px" style="text-align: center;">{{ "poItemNo" | translate}}</th>
              <th scope="col" nzWidth="100px" style="text-align: center;">{{ "unpaidQty" | translate}}</th>
              <th scope="col" nzWidth="120px" style="text-align: center;">{{ "poQty" | translate}}
                <div style="margin-top: 5px;">
                  <span (click)="AsFirst('poQty')" nz-icon nzType="vertical-align-bottom" nzTheme="outline"
                    style="font-size: 20px;cursor: pointer;"></span>
                </div>
              </th>
              <th scope="col" nzWidth="100px" style="text-align: center;">{{ "NotTaxAmount" | translate}}

              </th>
              <th scope="col" nzWidth="100px" style="text-align: center;">{{ "PATax" | translate}} </th>
              <th scope="col" nzWidth="400px" style="text-align: center;">{{ "itemDesc" | translate}}</th>
              <th scope="col" nzWidth="100px" style="text-align:center ;background-color: #fff;" class="fixed-column">{{
                "act" | translate}}</th>
            </tr>
          </thead>
          <ng-container formArrayName="RTDetail">
            <tr [formGroupName]="i" *ngFor="let data of RTDetail.controls;let i=index">
              <ng-container>
                <td> <nz-select formControlName="DetailInvoiceNo" style="width: 100%;" (click)="SelectInvoiceNo()"
                    (ngModelChange)="SelectInvoiceNoChange()">
                    <nz-option *ngFor="let o of DetailInvoiceNoList;let i=index" [nzValue]="o" [nzLabel]="o"
                      nzCustomContent>
                      <span>{{o}}</span>
                    </nz-option>
                  </nz-select></td>
                <td> {{data.value.Pono}}</td>
                <td>
                  <nz-select formControlName="poItemNo" style="width: 100%;"
                    (ngModelChange)="poItemNoChange(data.value,i,$event)">
                    <nz-option *ngFor="let o of poItemNoList;let i=index" [nzValue]="o" [nzLabel]="o" nzCustomContent>
                      <span>{{o}}</span>
                    </nz-option>
                  </nz-select>
                </td>
                <td style="text-align: right; word-break:break-all;"> {{data.value.amount | number: '1.2-2'}}</td>
                <td style="text-align: right; word-break:break-all;"> {{data.value.price | number: '1.2-2'}}</td>
                <td style="text-align:right;"> {{data.value.poQty}}</td>
                <td style="text-align:right;"> {{data.value.unpaidQty}}</td>
                <td> <input nz-input formControlName="deliveryQty" style="text-align:right;" type="number" min="0"
                    (ngModelChange)="deliveryQtyChange($event,data.value,i)" /> </td>
                <td> <input type="text" oninput="value" nz-input formControlName="NotTaxAmount"
                    style="text-align:right;" /></td>
                <td> <input type="text" oninput="value" nz-input formControlName="PATax" style="text-align:right;" />
                </td>
                <td>{{data.value.itemDesc}}</td>
                <td style="text-align:center ;background-color: #fff;" class="fixed-column">
                  <span nz-icon nzType="delete" nzTheme="twotone" (click)="deleteDetail(i,data.value)"
                    style="font-size: 20px; cursor: pointer;" nz-tooltip
                    nzTooltipTitle="{{'Delete' | translate}}"></span>
                </td>
              </ng-container>
            </tr>
          </ng-container>
        </nz-table>
      </nz-card>

    </form>
    <nz-modal [(nzVisible)]="isdepartmentCharge" nzTitle='{{"departmentCharge"|translate}}'
      (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()" style="width: 600px;" nzMaskClosable="false">
      <ng-container *nzModalContent>
        <nz-table #basicTable [nzData]="departData">
          <thead>
            <tr>
              <th scope="col" style="width: 120px;">{{'deptCode'|translate}}</th>
              <th scope="col" style="width: 180px;">{{'ChangeDepartment'|translate}}</th>
              <th scope="col" style="width: 120px;">{{'Percentage'|translate}}</th>
              <th scope="col" style="width: 120px;">{{'ChangeTime'|translate}}</th>
              <th scope="col" style="width: 120px;">{{'act'|translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of basicTable.data">
              <ng-container *ngIf="!editCache[data.id].edit; else editTemplate">
                <td>{{ data.cDeptno}}</td>
                <td>{{data.mDeptno}}</td>
                <td>{{ data.dis}}%</td>
                <td>{{data.maintainTime}}</td>
                <td><a (click)="startEdit(data.id)">{{'Edit'|translate}}</a></td>
              </ng-container>
              <ng-template #editTemplate>
                <td><input type="text" nz-input [(ngModel)]="editCache[data.id].data.cDeptno" [disabled]="true" /></td>
                <td>
                  <nz-form-control>
                    <nz-select [nzServerSearch]="true" [(ngModel)]="editCache[data.id].data.mDeptno"
                      (nzOnSearch)="ChangeselectDepart($event)" style="border-radius:6px;width:200px;"
                      nzPlaceHolder='{{"threeDepartment"|translate}}' [nzAllowClear]="true" [nzShowSearch]="true">
                      <nz-option *ngFor="let o of SelectDepartdata" [nzValue]="o.deptId"
                        nzLabel="{{o.deptId}}/{{o.deptName}}" nzCustomContent style="width: 200px;">
                        <span>{{o.deptId}}/{{o.deptName}}</span>
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </td>
                <td><input type="text" nz-input [(ngModel)]="editCache[data.id].data.dis" [disabled]="true" /></td>
                <td><input type="text" nz-input [(ngModel)]="editCache[data.id].data.maintainTime" [disabled]="true" />
                </td>
                <td>
                  <a (click)="saveEdit(data.id)" class="save" style="margin-right: 30px;">{{'Save'|translate}}</a>

                  <a nz-popconfirm nzPopconfirmTitle="Sure to cancel?"
                    (nzOnConfirm)="cancelEdit(data.id)">{{'Cancel'|translate}}</a>
                </td>
              </ng-template>

            </tr>
          </tbody>
        </nz-table>


      </ng-container>
      <div *nzModalFooter style="margin-left: 770px;">
        <button nz-button nzType="primary" class="default-button;" (click)="handleOk()">{{"Cancel" |translate
          }}</button>
      </div>
    </nz-modal>
    <nz-modal [(nzVisible)]="RemarkVisible" nzTitle='{{"Remark"|translate}}' (nzOnCancel)="RejectCancel()"
      (nzOnOk)="RejectOk()">
      <ng-container *nzModalContent>
        <textarea rows="6" nz-input [(ngModel)]="RejectinputValue"></textarea>
      </ng-container>
    </nz-modal>




  </div>
</nz-spin>

<nz-modal [(nzVisible)]="GetPaymentInfo" nzTitle='{{"PaymentInformationDetails" |translate}}'
  (nzOnCancel)="disablePaymentInfo()" (nzOnOk)="PaymentInfoOk()" [nzWidth]="1200"
  nzClassName="custom-payment-info-modal">

  <ng-container *nzModalContent>

    <nz-spin [nzSpinning]="isLoadingPaymentInfo">
      <h3 [ngStyle]="{ 'margin-bottom.px': 16 }">{{'departmentCharge'|translate}}</h3>
      <nz-list nzBordered>
        <nz-table #basicTable [nzData]="editDeptsdata" [nzShowPagination]="false">
          <thead>
            <tr>
              <th scope="col" style="width: 120px;">{{'deptCode'|translate}}</th>
              <th scope="col" style="width: 180px;">{{'ChangeDepartment'|translate}}</th>
              <th scope="col" style="width: 120px;">{{'Percentage'|translate}}</th>
              <th scope="col" style="width: 120px;">{{'act'|translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of editDeptsdata">
              <ng-container *ngIf="!editDepts[item.itemNo].edit;else editTemplate">
                <td>{{ item.originalChargeDeptNo }}</td>
                <td>{{ item.chargeDeptNo}}</td>
                <td>{{ item.dis }}%</td>
                <td><a (click)="startEditDepts(item.itemNo)">{{'Edit'|translate}}</a></td>
              </ng-container>
              <ng-template #editTemplate>
                <td><input type="text" nz-input [(ngModel)]="editDepts[item.itemNo].data.originalChargeDeptNo"
                    [disabled]="true" /></td>
                <td>
                  <nz-form-control>
                    <nz-select [nzServerSearch]="true" [(ngModel)]="editDepts[item.itemNo].data.chargeDeptNo"
                      (nzOnSearch)="ChangeselectDepart($event)" style="border-radius:6px;width:200px;"
                      nzPlaceHolder='{{"threeDepartment"|translate}}' [nzAllowClear]="true" [nzShowSearch]="true">
                      <nz-option *ngFor="let o of SelectDepartdata" [nzValue]="o.deptId"
                        nzLabel="{{o.deptId}}/{{o.deptName}}" nzCustomContent style="width: 200px;">
                        <span>{{o.deptId}}/{{o.deptName}}</span>
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </td>
                <td><input type="text" nz-input [(ngModel)]="editDepts[item.itemNo].data.dis" [disabled]="true" /></td>
                <td>
                  <a (click)="saveEditDepts(item.itemNo)" class="save"
                    style="margin-right: 30px;">{{'Save'|translate}}</a>

                  <a nz-popconfirm nzPopconfirmTitle="Sure to cancel?"
                    (nzOnConfirm)="cancelEditDepts(item.itemNo)">{{'Cancel'|translate}}</a>
                </td>
              </ng-template>
            </tr>
          </tbody>
        </nz-table>

      </nz-list>
      <h3 [ngStyle]="{ 'margin-bottom.px': 16 }">{{'PaymentInformationInvoiceList'|translate}}</h3>
      <nz-list nzBordered>
        <nz-table #basicTable [nzData]="Inv[0]" [nzShowPagination]="false">

          <thead>
            <tr>
              <th scope="col" nzWidth="30px">{{'InvoiceNo'|translate}}</th>
              <th scope="col" nzWidth="60px">{{'InvoiceDate'|translate}}</th>
              <th scope="col" nzWidth="60px">{{'Expect Due Date'|translate}}</th>
              <th scope="col" nzWidth="60px">{{'TheInvoiceType'|translate}}</th>
              <th scope="col" nzWidth="60px">{{'InvoiceAmountBeforeTax'|translate}}</th>
              <th scope="col" nzWidth="60px">{{'Taxes'|translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Inv[0]">
              <td>{{ item.invoiceNo }}</td>
              <td>{{ item.invoiceDate | date:'yyyy-MM-dd' }}</td>
              <td>
                <nz-date-picker [(ngModel)]="item.expectDueDate" [nzFormat]="dateFormat" style="width:100%;"
                  [nzDisabledDate]="disabledExpectDueDate" [nzDefaultPickerValue]="expectDueDateDefault" nzPlaceHolder="{{'selectMonth'|translate}}">
                </nz-date-picker>
              </td>
              <td>{{ item.invoiceType }}</td>
              <td>{{ item.amount }}</td>
              <td>{{ item.tax }}</td>
            </tr>
          </tbody>
        </nz-table>

      </nz-list>

      <h3 [ngStyle]="{ 'margin-bottom.px': 16 }">{{'DetailedInformationList'|translate }}</h3>
      <nz-list nzBordered>
        <nz-table #basicTable [nzData]="Pay[0]" [nzShowPagination]="false">

          <thead>
            <tr>
              <th scope="col" nzWidth="60px">{{'LineNo'|translate}}</th>
              <th scope="col" nzWidth="60px">{{'PoNo'|translate}}</th>
              <th scope="col" nzWidth="60px">{{'table.POLN'|translate}}</th>
              <th scope="col" nzWidth="60px">{{'InvoiceNo'|translate}}</th>
              <th scope="col" nzWidth="150px">{{'table.RTNo'|translate}}</th>
              <th scope="col" nzWidth="70px">{{'table.RTLine'|translate}}</th>
              <th scope="col" nzWidth="100px">{{'poQty'|translate}}</th>
              <th scope="col" nzWidth="60px">{{'NotTaxAmount'|translate}}</th>
              <th scope="col" nzWidth="60px">{{'PATax'|translate}}</th>

            </tr>
          </thead>
          <tbody>

            <tr *ngFor="let item of Pay[0];let i=index">
              <td>{{ item.itemNo }}</td>
              <td>{{ item.poNo }}</td>
              <td>{{ item.poItemNo }}</td>
              <td>{{ item.invoiceNo }}</td>
              <td>
                <nz-select [(ngModel)]="item.rtNo" style="width: 100%;" nzPlaceHolder="Select"
                  (click)="RtNoclick(item,i)" (ngModelChange)="RtNoChange(item,$event,i)">
                  <nz-option *ngFor="let option of item.rtNoOptions" [nzValue]="option" [nzLabel]="option"></nz-option>
                </nz-select>
              </td>
              <td>
                <nz-select [(ngModel)]="item.rtItemNo" style="width: 100%;" nzPlaceHolder="Select">
                  <nz-option *ngFor="let option of item.rtItemNoOptions" [nzValue]="option"
                    [nzLabel]="option"></nz-option>
                </nz-select>
              </td>
              <td>
                <input type="text" nz-input [(ngModel)]="item.qty" (ngModelChange)="qtyChange(item,$event,i)"
                  style="width: 100%;text-align:right;" type="number">
              </td>
              <td style="text-align:right;">{{ item.amount }}</td>
              <td style="text-align:right;">{{ item.tax }}</td>

            </tr>
          </tbody>
        </nz-table>
      </nz-list>
    </nz-spin>
  </ng-container>
</nz-modal>
